'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

var _reduxActions = require('redux-actions');

var _actionTypes = require('../constants/actionTypes');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = (0, _immutable.OrderedSet)();

exports.default = (0, _reduxActions.handleActions)(_defineProperty({}, _actionTypes.REFRESH_WIDGET_DATA, function (state, action) {
  var widgetData = action.payload;

  return state.add(widgetData);
}), initialState);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/widget-data/reducers/refreshedWidgetData.js
// module id = 859
// module chunks = 2 3